import { Injectable } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { Base } from "./base";
import { isString } from "./class.helpers";
import {
    Unit as T,
    ParkingSpace, Warehouse, UnitPhoto, Property, Investor, Insurance, Contract, UnitsSummary, TypeUnit
} from '../Interfaces';

@Injectable()
export class Unit extends Base implements T {
    unit_id: number;
    id_orange: string;
    floor: string;
    in_pool: number;
    area_interior: number;
    area_common: number;
    area_terrace: number;
    area_in_pool: number;
    total_area: number;
    total_area_pool: number;
    pool_percentage: number;
    id: number;
    motto_value: number;
    constructor(json?: T,
        public property?: Property,
        public investor?: Investor,
        public contract?: Contract,
        public insurance?: Insurance,
        public parking_spaces?: ParkingSpace[],
        public warehouses?: Warehouse[],
        public type_unit?: TypeUnit,
        public photos?: (UnitPhoto | SafeUrl)[],
        public summary?: UnitsSummary
    ) {
        super(json);
        if (json && 'unit_id' in json) this.id = this.unit_id;
        if (isString(this.area_interior)) this.area_interior = Number(this.area_interior);
        if (isString(this.area_common)) this.area_common = Number(this.area_common);
        if (isString(this.area_terrace)) this.area_terrace = Number(this.area_terrace);
        if (!this.total_area) this.total_area = this.getTotalArea();
        if (!this.area_in_pool) this.area_in_pool = this.getTotalAreaPool();
    }

    getTotalArea() {
        if (this.total_area == null)
            this.calculateTotalArea();
        return this.total_area;
    }
    getTerrace50() {
        if (this.area_in_pool == null)
            this.calculateTerrace50();
        return this.area_in_pool;
    }
    getPoolPercentage() {
        if (this.pool_percentage == null)
            this.calculatePoolPercentage();
        return this.pool_percentage;
    }
    set areas(object) {
        if (object.area_interior != null)
            this.area_interior = object.area_interior;
        if (object.area_common != null)
            this.area_common = object.area_common;
        if (object.area_terrace != null)
            this.area_terrace = object.area_terrace;
        if (object.motto_value != null)
            this.motto_value = object.motto_value;
    }
    calculate(totalAMottoValueOffset?: number) {
        this.calculateTotalArea();
        this.calculateTerrace50();
        this.calculatePoolPercentage(totalAMottoValueOffset);
    }
    private calculatePoolPercentage(totalAMottoValueOffset?: number) {
        if (!this.in_pool) {
            this.pool_percentage = 0;
            return;
        }
        if (this.summary) {
            if (this.summary.in_pool == 0) {
                this.pool_percentage = 100;
            }
            else {
                let total_motto_value_pool = (totalAMottoValueOffset) ? totalAMottoValueOffset : 0;
                total_motto_value_pool += this.summary.all_motto_value_pool;
                if (total_motto_value_pool == 0)
                    this.pool_percentage = 0;
                else
                    this.pool_percentage = (this.motto_value / total_motto_value_pool) * 100;
            }
        }
    }
    private calculateTerrace50() {
        if (!this.in_pool) {
            this.area_in_pool = 0;
            return;
        }
        this.area_in_pool = this.getTotalAreaPool();//this.area_terrace / 2;
    }
    private calculateTotalArea() {
        this.total_area = this.area_interior + this.area_common + this.area_terrace;
    }
    getTotalAreaPool() {
        return this.area_interior + this.area_common;
    }

    getMottoValuePool() {
        return this.motto_value;
    }

    get name(): string {
        return this.id_orange;
    }
    toString(): string {
        return this.name;
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/unit.ts